/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Swift_Moth_YawnInputs */

const en_plum_swift_moth_yawn = /** @type {(inputs: Plum_Swift_Moth_YawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Information`)
};

const de_plum_swift_moth_yawn = /** @type {(inputs: Plum_Swift_Moth_YawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen`)
};

/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Plum_Swift_Moth_YawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_swift_moth_yawn = /** @type {((inputs?: Plum_Swift_Moth_YawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Swift_Moth_YawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_swift_moth_yawn(inputs)
	return de_plum_swift_moth_yawn(inputs)
});